import axios from "axios";
import configuration from "@/utils/configuration";

export const schoolService = {
  getSchoolList() {
    return axios.get(`${configuration.backUrl}/school`);
  },

  getSchoolById(schoolId) {
    return axios.get(`${configuration.backUrl}/school/search`, {
      params: { school_id: schoolId },
    });
  },

  getClassList() {
    return axios.get(`${configuration.backUrl}/class`);
  },

  getClassById(classId) {
    return axios.get(`${configuration.backUrl}/class/search`, {
      params: { class_id: classId },
    });
  },

  deleteUser(userId) {
    return axios.delete(`${configuration.backUrl}/users/management`, {
      params: { user_id: userId },
    });
  },
};
